import React from 'react'
import { customerData } from '../../../utilities/CustomerData'

export function DashboardPendingBank() {
  function MultilineText({ text, textColor }) {
    const lines = text.split('\\n')

    const renderTextWithItalics = (text) => {
      const parts = text.split(/(<i>|<\/i>|<b>|<\/b>)/)
      let isInItalic = false
      let isInBold = false

      return parts.map((part, index) => {
        if (part === "<i>") {
          isInItalic = true
          return null
        } else if (part === "</i>") {
          isInItalic = false
          return null
        } else if (part === '<b>') {
          isInBold = true
          return null
        } else if (part === '</b>') {
          isInBold = false
          return null
        } else {
          if (isInItalic && isInBold) {
            return (
              <b key={index}>
                <i>{part}</i>
              </b>
            )
          } else if (isInItalic)
            return <i key={index}>{part}</i>
          else if (isInBold)
            return <b key={index}>{part}</b>
          else
            return part
        }
      })
    }

    return (
      <div className={`text-left text-${textColor} mt-4`}>
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {renderTextWithItalics(line)}
            {index !== lines.length - 1 && <><br /><div style={{ height: '8px' }} /></>}
          </React.Fragment>
        ))}
      </div>
    )
  }

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center gap-4'>
          <div className='w-full flex flex-col items-center gap-4'>
            <button 
              onClick={() => window.innerWidth <= 768 ? window.location.href = customerData.customerValidiFiBankVerification.accessUrl : window.open(customerData.customerValidiFiBankVerification.accessUrl, '_blank')}
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center gap-2'>
                  <p>Validate Bank</p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
            <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
              <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
              <iframe className='w-full aspect-video' src="https://www.loom.com/embed/9f524295b9f34cff93b77906de1de0b4?sid=b12b3432-be9d-4d42-b8ca-507d956e431c&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <p className='font-bold text-2xl'>When you receive your microdeposit, click above to enter your code.</p>
            <p className='font-bold text-xl'>Micro Deposit Estimate Date:</p>
            <p className='font-bold text-xl'>{new Date(customerData.customerValidiFiBankVerification.estimatedDepositDate).toDateString()}</p>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <div className='w-full flex flex-col items-start gap-4'>
          <p className='font-bold text-xl text-[#646464]'>Your Application is Being Processed</p>
          <p className='text-xl text-[#646464]'>We're excited to let you know that your application is now in progress! To continue, please complete the ValidiFi verification process. This step ensures your funds will be securely routed to your bank account.</p>
          <p className='font-bold text-xl text-[#646464]'>Rest assured, this process is fully encrypted, and your payment information will remain secure. We will never share your information with third parties.</p>
          <p className='font-bold text-xl text-[#646464]'>Here's how it works:</p>
          <p className='text-xl text-[#646464]'>Secure verification - We've partnered with ValidiFi, a trusted service that ensures the security of your account throughout the process.</p>
          <p className='text-xl text-[#646464]'><span className='font-bold'>Provide your bank account details -</span> We will use an ACH transfer to deposit funds directly into your account.</p>
          <p className='text-xl text-[#646464]'><span className='font-bold'>Micro deposits -</span> ValidiFi will make micro deposits (usually les than $1) to verify your account. You will receive notifications regarding the status of your micro-deposit, including when to expect it. Please note, this process may take 1-5 days to receive, so be sure to watch for updates in your notifications to stay informed.</p>
          <p className='text-xl text-[#646464]'><span className='font-bold'>4-Character Verification Code -</span> You will receive easy-to-follow instructions to confirm these deposits and verify your account with a 4 digit code. You will have this code on your bank statement with the micro-deposit transaction. This will appear after the "ACCTVERIFY-" on your statement.</p>
        </div>
      </div>
    </div>
  )
}